module.exports = __webpack_public_path__ + "img/drag_group_color_default.5445232b.png";